import React from 'react';
import { useTranslation } from 'react-utilities';
import { NAPageItemConfigType } from '../ConfigTypes';
import getRobloxUrl from '../../utils/getRobloxUrl';
import makeTranslateWithLink from '../../utils/makeTranslateWithLink';
import { EventTypes } from '../../services/eventConstants';

/**
 * Appeals related notice. Shown to users if they cannot reactivate
 */
const AppealsNoticePageItem = (): JSX.Element => {
  const { translate } = useTranslation();
  const translateWithLink = makeTranslateWithLink(translate);

  // TODO(MODSERV-1516): link to specific violation by UID
  return (
    <div data-testid='appeals-notice'>
      {translateWithLink(
        'Description.AppealWithPortal',
        getRobloxUrl('/report-appeals?t_source=nap-web'),
        undefined,
        EventTypes.AppealsPortalClicked
      )}
    </div>
  );
};

const AppealsNoticePageItemConfig: NAPageItemConfigType = {
  getIsVisible: () => {
    return true;
  },
  renderComponent: AppealsNoticePageItem,
  configName: 'appeals-notice'
};

export default AppealsNoticePageItemConfig;
